export const CONFIG = {
  REACT_APP_BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
  /** Cognito auth Lambda — signup/login/confirm + signup-time /billing/signup/* only. */
  LAMBDA_URL: process.env.REACT_APP_LAMBDA_URL,
  /** Plans Lambda (VPC/RDS only) — GET /plans. */
  PLANS_BILLING_URL: process.env.REACT_APP_PLANS_BILLING_URL,
  /**
   * Support-report Lambda Function URL (SES, no VPC).
   * Used when the main API is down; see infra/support-report-lambda/.
   */
  SUPPORT_LAMBDA_URL: process.env.REACT_APP_SUPPORT_LAMBDA_URL,
  /** Workspace host suffix for landing signup links. Prod keeps nova.bizacuity.ai. */
  REACT_APP_TENANT_ROOT_DOMAIN: process.env.REACT_APP_TENANT_ROOT_DOMAIN,
};
